import script from "./SocialNetworkEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./SocialNetworkEdit.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__